import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { QueryBuilderContext } from '../QueryBuilderContext/QueryBuilderContext.js';
import { QB_DRAG_TYPES } from '../helpers/types.js';
import AndOrController from '../AndOrController/AndOrController.js';
import QueryBuilderRow from '../QueryBuilderRow/QueryBuilderRow.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';
import '@elliemae/ds-basic/Tooltip';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-basic/form/Toggle';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/QueryAdd';
import '@elliemae/ds-icons/ParenthesisRemove';
import '@elliemae/ds-icons/MoreOptionsVert';
import '@elliemae/ds-basic/Icon';
import '../helpers/constants.js';
import '../ToolBarAnimation/ToolBarAnimation.js';
import '@elliemae/ds-shared/Animations/GrowRight';
import '../DragContainerController/DragContainerController.js';
import '@elliemae/ds-icons/GripperVertical';
import '../helpers/dependencies.js';
import 'lodash';
import '@elliemae/ds-utilities/operators';
import '../ConditionController/ConditionController.js';
import '@elliemae/ds-icons/QueryRemove';
import '@elliemae/ds-icons/ParenthesisAdd';
import '../DragControllerRow/DragControllerRow.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';

var QueryBuilderItem = function QueryBuilderItem(_ref) {
  var item = _ref.item;
  var element = item.element;
  var type = element.type,
      idFilter = element.idFilter,
      idGroup = element.idGroup,
      condition = element.condition;
  return /*#__PURE__*/React.createElement(QueryBuilderContext.Consumer, null, function (_ref2) {
    var fields = _ref2.fields,
        handleFieldChange = _ref2.handleFieldChange,
        _onAddFilter = _ref2.onAddFilter,
        onAddFilterToGroup = _ref2.onAddFilterToGroup,
        _onAddRuleContainer = _ref2.onAddRuleContainer,
        _onRemoveFilter = _ref2.onRemoveFilter,
        showDragController = _ref2.showDragController,
        _handleRuleContainerOperator = _ref2.handleRuleContainerOperator,
        _handleRuleContainerUnGroup = _ref2.handleRuleContainerUnGroup,
        step = _ref2.step,
        items = _ref2.items,
        isDraggableItem = _ref2.isDraggableItem,
        setDraggableItems = _ref2.setDraggableItems,
        singleRow = _ref2.singleRow,
        toolTipZIndex = _ref2.toolTipZIndex;

    if (type === QB_DRAG_TYPES.FILTER) {
      return /*#__PURE__*/React.createElement(QueryBuilderRow, _extends({}, element, {
        fields: fields,
        handleFieldChange: handleFieldChange,
        isDraggableItem: isDraggableItem,
        items: items,
        onAddFilter: function onAddFilter() {
          return _onAddFilter(idGroup, idFilter);
        },
        onAddRuleContainer: function onAddRuleContainer() {
          return _onAddRuleContainer(idGroup, idFilter);
        },
        onRemoveFilter: function onRemoveFilter() {
          return _onRemoveFilter(idFilter);
        },
        setDraggableItems: setDraggableItems,
        showDragController: showDragController,
        step: step,
        singleRow: singleRow,
        toolTipZIndex: toolTipZIndex
      }));
    }

    if (singleRow) return null;
    return /*#__PURE__*/React.createElement(AndOrController, {
      allowUnGroup: true,
      condition: condition,
      handleRuleContainerOperator: function handleRuleContainerOperator(value) {
        return _handleRuleContainerOperator(idGroup, value);
      },
      handleRuleContainerUnGroup: function handleRuleContainerUnGroup() {
        return _handleRuleContainerUnGroup(idGroup);
      },
      multipleSize: false,
      onAddFilter: function onAddFilter() {
        return onAddFilterToGroup(idGroup);
      },
      showDragController: true,
      step: step,
      toolTipZIndex: toolTipZIndex
    });
  });
};

export default QueryBuilderItem;
//# sourceMappingURL=QueryBuilderItem.js.map
